import React, {memo} from "react"
import Products from "../../../../components/products"
import FiltersComponent from "../../../../components/filters"
import MobileHeader from "../../../../components/mobileHeader"
import ResultsGrid from "../../../../components/resultsGrid"
import ViewAllModal from "../../../../components/viewAllModal"
import NoResults from "../../../../components/noResults"
import CategoryQuickLinks from "../../../../components/categoryQuickLinks"
import {CategoryQuickLinksContainer, NoResultsContainer} from "../../components"
import ProductsHeader from "../../../../components/productsHeader"
import {ProductsRoot} from "../../../../components/products/components"
import PlpContainer from "../../../../components/container"
import SearchBannerProvider from "../../../../components/searchBannerProvider"
import {RelativeContainer} from "./components"

export interface StandardPLPResultsContainerProps {
    noResults: boolean
    relaxedQuery: string
}

export const StandardPLPResultsContainer = memo(({noResults, relaxedQuery}: StandardPLPResultsContainerProps) => {
    return noResults ? (
        <PlpContainer testId="plp-container">
            <NoResultsContainer>
                <NoResults />
            </NoResultsContainer>
            <CategoryQuickLinksContainer>
                <CategoryQuickLinks />
            </CategoryQuickLinksContainer>
        </PlpContainer>
    ) : (
        <PlpContainer testId="plp-container">
            <RelativeContainer data-testid="plp-mobile-header">
                <MobileHeader />
            </RelativeContainer>
            <ResultsGrid container>
                <FiltersComponent datatestId="plp-filters-component-desktop" />
                <ProductsRoot>
                    <SearchBannerProvider paddingTop={relaxedQuery === "" ? 3 : 4}>
                        <ProductsHeader />
                    </SearchBannerProvider>

                    <Products />
                </ProductsRoot>
            </ResultsGrid>
            <ViewAllModal />
        </PlpContainer>
    )
})
StandardPLPResultsContainer.displayName = "StandardPLPResultsContainer"

export default StandardPLPResultsContainer
